<script setup lang="ts">
import AppButton from './AppButton.vue';
import AppTypography from './AppTypography.vue';

const {
  errorMessages = undefined,
  resendTime = 300, // 5 mins
  length = 5,
  isResendSuccess = false,
  resendLoading = false,
  showResend = true,
  loading = false,
} = defineProps<{
  errorMessages?: string;
  resendTime?: number;
  length?: number;
  isResendSuccess?: boolean;
  resendLoading?: boolean;
  showResend?: boolean;
  loading?: boolean;
}>();

const emits = defineEmits<{
  (e: 'resend'): void;
}>();

const timerRunning = ref(false);
const timer = ref(resendTime);

watch(
  () => isResendSuccess,
  () => {
    if (isResendSuccess) {
      timerRunning.value = true;
      const timerInterval = setInterval(() => {
        timer.value--;
        if (timer.value <= 0) {
          clearInterval(timerInterval);
          timerRunning.value = false;
        }
      }, 1000);
    }
  }
);

const formattedTime = computed(() => {
  const minutes = Math.floor(timer.value / 60);
  const seconds = timer.value % 60;
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
});

defineExpose({
  formattedTime,
  timerRunning,
});

const otp = defineModel<string>({
  default: '',
});
</script>

<template>
  <div class="otp-container gap-xl d-flex flex-column">
    <v-otp-input
      v-model="otp"
      variant="solo-filled"
      data-testid="app-otp"
      data-cy="input-otp"
      class="pa-0"
      :length="length"
      :error="Boolean(errorMessages)"
      autofocus
    ></v-otp-input>
    <v-messages
      color="error"
      class="mt-1"
      v-if="errorMessages"
      :active="Boolean(errorMessages?.length)"
      :messages="errorMessages"
    ></v-messages>
    <div v-if="showResend" class="otp-request text-center d-flex justify-center align-center">
      <AppTypography element="span">Didn’t get the code?</AppTypography>

      <AppButton
        class="pa-0"
        size="small"
        variant="tertiary"
        v-if="!timerRunning"
        :loading="resendLoading"
        @click="emits('resend')"
      >
        <AppTypography class="font-body-bold">Resend Code</AppTypography>
      </AppButton>
      <div v-else>
        <!-- <AppTypography class="text-disabled font-weight-bold" element="span" type="headline-1"
          >Resend in {{ formattedTime }}</AppTypography
        > -->
        <AppButton class="pa-0" size="small" variant="tertiary">
          <AppTypography class="font-body-bold text-disabled">Resend in {{ formattedTime }}</AppTypography>
        </AppButton>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@use '~/assets/scss/_fonts.scss' as *;

.v-otp-input {
  :deep(.v-otp-input__content) {
    padding: 0;
  }
}
:deep(.v-otp-input .v-otp-input__content) {
  width: 100%;
  max-width: 450px !important;
  gap: 16px !important;
  height: 80px !important;
}
.otp-request {
  gap: 4px;
  @include body-font(400, 16px, 16px);
}
</style>
